import { useQuery } from "@tanstack/react-query";
import { ClaimControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseData,
} from "../../../utils/utils";

interface ClaimProps {
  claimType?: string;
  tenant?: string;
}

/**
 *
 * @author Atish Bagate
 */
export function useGetClaimCount({
  claimType,
  tenant,
}: ClaimProps): useBaseData<any> {
  return useQuery({
    queryKey: ["Get-claim-count", claimType, tenant],
    refetchOnWindowFocus: false,
    staleTime: 30000,
    queryFn: async () =>
      new ClaimControllerApi(getConfigObject())
        .getClaimStatusCounts(claimType, tenant ?? getXtenantId())
        .then((it) => it?.data),
  });
}
